import styled from '@emotion/styled';
import { LogoGamblingHelpline } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/LogoGamblingHelpline';
import { LogoTakeTimeToThink } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/LogoTakeTimeToThink';

export const LogoTakeTimeToThinkWrapper = styled(LogoTakeTimeToThink, { label: 'LogoTakeTimeToThinkWrapper' })`
    display: block;
    width: 168px;
`;

export const LogoGamblingHelplineWrapper = styled(LogoGamblingHelpline, { label: 'LogoGamblingHelplineWrapper' })`
    display: block;
    width: 166px;
`;
